import api from '../config/api';
import {
  UserGeneratedContentResponse,
  UGCFormState,
  UserGeneratedContentStatus,
} from '../models/user-generated-contents/types';

export const updateStatusUrlMap = {
  active: 'restore',
  submitted: 'submit',
  archived: 'archive',
} as const;

class UserGeneratedContentService {
  id: number | undefined;

  constructor(id: number | undefined) {
    this.id = id;
  }

  fetch = () => {
    return api.get<UserGeneratedContentResponse>(
      `/user_generated_contents/${this.id}`
    );
  };

  create = (data: UGCFormState) => {
    return api.post<UserGeneratedContentResponse>(
      '/user_generated_contents',
      data
    );
  };

  update = (data: UGCFormState) => {
    return api.put<UserGeneratedContentResponse>(
      `/user_generated_contents/${this.id}`,
      data
    );
  };

  updateStatus = (status: UserGeneratedContentStatus) => {
    const path = `/user_generated_contents/${this.id}/${updateStatusUrlMap[status]}`;

    return api.post<UserGeneratedContentResponse>(path);
  };
}

export default UserGeneratedContentService;
